import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetTariffPlans = companyId => {
  return useQuery({
    queryKey: [QUERY_KEYS.fundraising.tariff_plans, companyId],
    queryFn: () =>
      fundraisingService.tariffPlans({ company_id: companyId }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
